import { camelToStartCase } from "@repo/helpers";

import type { Marker } from "./map";

export function createInfoWindowContent(marker: Pick<Marker, "label" | "links">, onOpenStreetView: () => void) {
	const details = document.createElement("dl");
	Object.assign(details.style, {
		display: "grid",
		gridTemplateColumns: "1fr 2fr",
		gap: "4px",
		paddingBottom: "4px",
	});

	for (const link of marker.links ?? []) {
		details.append(term(link.label), linkDetail(link.href, link.value));
	}
	for (const entry of marker.label) {
		for (const [key, value] of Object.entries(entry)) {
			details.append(term(camelToStartCase(key)), textDetail(value));
		}
	}

	const streetViewButton = document.createElement("button");
	streetViewButton.type = "button";
	streetViewButton.textContent = "Open Street View";
	streetViewButton.style.color = "blue";
	streetViewButton.addEventListener("click", onOpenStreetView);

	const actions = document.createElement("div");
	Object.assign(actions.style, { display: "flex", flexDirection: "column", alignItems: "start", gap: "4px" });
	actions.append(streetViewButton);

	const content = document.createElement("div");
	content.style.color = "black";
	content.append(details, actions);
	return content;
}

function term(label: string) {
	const element = document.createElement("dt");
	element.style.fontWeight = "bold";
	element.textContent = `${label}:`;
	return element;
}

function textDetail(value: unknown) {
	const element = document.createElement("dd");
	element.textContent = String(value ?? "");
	return element;
}

function linkDetail(href: string, value: unknown) {
	const safeHref = toSafeHref(href);
	if (!safeHref) return textDetail(value);

	const anchor = document.createElement("a");
	anchor.href = safeHref;
	anchor.target = "_blank";
	anchor.rel = "noopener";
	Object.assign(anchor.style, { color: "blue", textDecoration: "underline" });
	anchor.textContent = String(value ?? "");

	const element = document.createElement("dd");
	element.append(anchor);
	return element;
}

function toSafeHref(href: string | undefined) {
	if (!href) return undefined;
	try {
		const { protocol } = new URL(href, window.location.href);
		return protocol === "http:" || protocol === "https:" ? href : undefined;
	} catch {
		return undefined;
	}
}
